;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller  = APP.module('Controller');

	Controller.Root.prototype.on('init', Controller.Root.prototype.showFooter);

}(window, APP, Backbone, Marionette, $, _));